import { useRideOrderMarketplaceRoutes } from './rom/useRideOrderMarketplaceRoutes';
import { TabNavigation } from 'src/common/TabNavigation';
import { useShouldShowRideOrderingPortalFeatures } from 'src/features/rideOrderingPortal/useShouldShowRideOrderingPortalFeatures';

const tabs = [
  { name: 'Trips', href: '/trips' },
  {
    name: 'Subscriptions',
    href: '/trips/subscriptions',
    matcher: '/trips/subscriptions/*',
  },
];

const rideOrderingPortalTabs = [{ name: 'Trips', href: '/trips' }];

export function TripsNav() {
  const shouldUseRideOrderingPortalRoutes =
    useShouldShowRideOrderingPortalFeatures();

  const { tabs: nonRideOrderingTabs } = useRideOrderMarketplaceRoutes(tabs);

  const combinedNonRideOrderingTabs = [...nonRideOrderingTabs];
  combinedNonRideOrderingTabs.push({
    name: 'Route Templates',
    href: '/trips/route-templates',
  });

  return (
    <TabNavigation
      tabs={
        shouldUseRideOrderingPortalRoutes
          ? rideOrderingPortalTabs
          : combinedNonRideOrderingTabs
      }
    />
  );
}
